import type { DirectoryExtraFilters } from './api'

/** Must match server `DEFAULT_DIRECTORY_PAGE_SIZE` in `server/src/routes/directory.ts`. */
export const DIRECTORY_PLUMBERS_PAGE_SIZE = 50

/** Max plumbers fetched for map pins - fetched once, independent of scroll pagination.
 *  Kept modest: 1000 pins bloats the map data fetch (a ranked aggregation) and put
 *  ~36 KiB + several seconds on the directory critical path; 200 pins is ample. */
export const DIRECTORY_MAP_PLUMBER_LIMIT = 200

export const CERT_OPTIONS = [
  'Gas Safe Registered',
  'Public Liability Insured',
  'OFTEC',
  'City & Guilds',
  'CORGI Registered',
  'WaterSafe',
  'NICEIC',
  'NVQ',
  'Worcester Bosch Accredited',
  'CIPHE',
  'LPG Registered',
  'TrustMark',
  'Vaillant Advance Partner',
  'APHC Member',
  'HETAS Registered',
  'Baxi Accredited Installer',
  'Which? Trusted Trader',
  'Viessmann Installer',
  'Ideal Accredited Installer',
] as const

export function hasActiveFilters(f: DirectoryExtraFilters): boolean {
  return !!(f.hasPhotos || f.hasRating || f.emergencyOnly || f.certification)
}
